import { Injectable } from '@angular/core';
import { Badge } from '@capawesome/capacitor-badge';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class BadgeCountService {
  private unreadPushCount = 0;
  private unreadCommentsCount = 0;

  // Subjects para UI
  private unreadPushCount$ = new BehaviorSubject<number>(0);
  private unreadCommentsCount$ = new BehaviorSubject<number>(0);

  getUnreadPushCountObservable() {
    return this.unreadPushCount$.asObservable();
  }

  getUnreadCommentsCountObservable() {

    console.log('chamou get de chat count', this.unreadCommentsCount$.asObservable())
    return this.unreadCommentsCount$.asObservable();
  }

  constructor() {
    // Carrega do storage se existir, senão zero
    const push = Number(localStorage.getItem('unreadPushCount') ?? '0');
    const comments = Number(localStorage.getItem('unreadCommentsCount') ?? '0');

    console.log('constructor do service', comments )
    //console.log('constructor do service')

    this.unreadPushCount = push;
    this.unreadCommentsCount = comments;
    this.unreadPushCount$.next(push);
    this.unreadCommentsCount$.next(comments);
  }

  setUnreadPushCount(count: number) {
    this.unreadPushCount = count;
    this.unreadPushCount$.next(count); // emite pra 
    localStorage.setItem('unreadPushCount', count.toString());
    this.updateAppBadge();
  }

  setUnreadCommentsCount(count: number) {
    console.log('valor chat setado')
    console.log(count)
    this.unreadCommentsCount = count;
    this.unreadCommentsCount$.next(count); // emite pra UI
    localStorage.setItem('unreadCommentsCount', count.toString());
    this.updateAppBadge();
  }

  private async updateAppBadge(): Promise<void> {
    const total = this.unreadPushCount + this.unreadCommentsCount;
    const supported = await Badge.isSupported();
    if (supported.isSupported) {
      await Badge.set({ count: total });
    }
  }

  // async clearBadge(): Promise<void> {
  //   console.log('no service clear')
  //   this.unreadPushCount = 0;
  //   this.unreadCommentsCount = 0;
  //   this.unreadPushCount$.next(0);
  //   this.unreadCommentsCount$.next(0);
  //   const supported = await Badge.isSupported();
  //   if (supported.isSupported) {
  //     await Badge.set({ count: 0 });
  //   }
  // }

  async clearPushBadge(): Promise<void> {
    this.unreadPushCount = 0;
    this.unreadPushCount$.next(0);
    localStorage.setItem('unreadPushCount', '0');
    this.updateAppBadge();
  }
  
  async clearCommentsBadge(): Promise<void> {
    this.unreadCommentsCount = 0;
    this.unreadCommentsCount$.next(0);
    localStorage.setItem('unreadCommentsCount', '0');
    this.updateAppBadge();
  }
}
